module.exports = __webpack_public_path__ + "img/1.f558d28e.png";